import {
    Component,
    Input,
    OnInit,
    OnChanges,
    SimpleChanges,
    ChangeDetectorRef,
    Injectable,
    AfterViewInit,
    inject,
    OnDestroy
} from '@angular/core';
import { NguCarouselConfig } from "@ngu/carousel";
import { Store } from "@ngrx/store";
import { GenericConfig, EntityConfig } from '@signature-it/ngx-generic/config';
import { LanguageService, ShareDataService, EventBusService } from '@signature-it/ngx-generic/services';
import {EventData, EventName} from '@signature-it/ngx-generic/classes';
import { ILanguage } from '@signature-it/ngx-generic/interfaces';
import { ProductFullSolrDTO, CarouselDTO, PriceDTO } from '@signature-it/ngx-catalogue/models';
import { SolrProductService, OrdersService, ProductPageService_Generic } from '@signature-it/ngx-catalogue/services';
import { CatalogueActions } from '@signature-it/ngx-catalogue/store/actions';
import { CarouselLayout } from '@signature-it/ngx-catalogue/enums';
import * as fromSelectors from '@signature-it/ngx-catalogue/store/selectors';
import {EntityService, SolrEntityService } from '@signature-it/ngx-entity/services';
import * as EntityActions from '@signature-it/ngx-entity/store/actions';
import {Observable, Subscription} from "rxjs";

declare let _: any;
declare let localStorage: any;

@Injectable({
    providedIn: 'root'
})

@Component({
    selector: 'products-carousel',
    templateUrl: './products-carousel.html',
    styleUrls: ['./products-carousel.scss'],
    standalone: false
})
export class ProductsCarouselComponent_Generic implements OnInit, OnChanges, AfterViewInit, OnDestroy {
    @Input() item: ProductFullSolrDTO;
    @Input() related: CarouselDTO;
    @Input() type: string;
    @Input() openRuleCondition: string;
    @Input() layout: string = CarouselLayout.CAROUSEL;
    @Input() key: string;
    @Input() entityVar: string;
    @Input() isWebComponent: boolean;
    @Input() previewTemplateVar;
    @Input() carouselIndicators: boolean = false;
    CarouselLayout = CarouselLayout;
    currLang: ILanguage;
    items: any;//Array<ProductFullSolrDTO>;
    // itemsCount: Array<any>;
    configRows = 1;
    carouselBanner: NguCarouselConfig = {
        grid: {xs: 1, sm: 2, md: 4, lg: 5, all: 0},
        slide: 1,
        speed: 400,
        point: {
            visible: true
        },
        load: 2,
        velocity: 0,
        touch: true,
        easing: 'cubic-bezier(0, 0, 0.2, 1)',
        interval: {
            timing: 40000
        },
        loop: false,
        custom: 'banner'
    };
    loading = false;
    relatedItemsField: any;
    inventoryCheck = GenericConfig.inventoryCheck;
    solrCondition = [];
    protected shareSvc: ShareDataService;
    protected eventBusService: EventBusService;
    priceList$: Observable<PriceDTO[]>;
    protected subscriptionsList$: Array<Subscription> = [];


    constructor(protected cdr: ChangeDetectorRef,
                protected solrService: SolrProductService,
                protected langSvc: LanguageService,
                protected store$: Store<any>,
                protected ordersService: OrdersService,
                protected solrEntityService: SolrEntityService,
                protected productPageService: ProductPageService_Generic,
                protected entityService: EntityService) {
        this.shareSvc = inject(ShareDataService);
        this.eventBusService = inject(EventBusService);
        // grid
        this.carouselBanner.gridBreakpoints = this.shareSvc.gridBreakPoints;
        if(GenericConfig.productRelatedItemsGrid) {
            this.carouselBanner.grid = GenericConfig.productRelatedItemsGrid;
        }
        this.priceList$ = this.store$.select(fromSelectors.getCataloguePriceList);
    }


    ngAfterViewInit() {
        this.cdr.detectChanges();
    }

    ngOnInit() {
        // get previews for ProductCardComponent using.
        this.store$.dispatch(EntityActions.getPreviews());
        if(this.key && EntityConfig.ngxProductsCarousel[this.key]){
            this.insertCustomElementRelated();
        }
        if(this.isWebComponent) {
            this.initDataByGlobalProduct()
        }
    }


    setConfigRows() {
        const mobileBreakPoint = GenericConfig.mobileBreakPoint ? GenericConfig.mobileBreakPoint : 992;
        this.configRows = window.innerWidth < mobileBreakPoint ? 1 : this.related.rows;
    }

    insertCustomElementRelated(){
      this.related = new CarouselDTO(EntityConfig.ngxProductsCarousel[this.key]) ;
      this.setConfigRows();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.langSvc
            .getCurrentLanguage$()
            .subscribe(lang => {
                if (lang) {
                    this.currLang = lang;
                    this.carouselBanner.RTL = this.langSvc.isRTL( lang );
                    if (changes['related']) {
                        // this.related = new CarouselDTO(this.related);
                        // this.configRows = this.related.rows;
                        this.setConfigRows();
                    }
                    if (this.type === 'promo' && (GenericConfig.carouselHP || GenericConfig.POSLineProducts) && (changes['related'] || (this.key && EntityConfig.ngxProductsCarousel[this.key] ) ) ) {
                        this._setRelatedProductItems(this.currLang, this.item?.product_id_i, true);
                    }
                    if (this.type === 'openRelatedItems' && changes['item']) {
                        this.getProductsByCondition();
                    }
                    if (this.type === 'relatedItems' && (changes['item'] || changes['solrCondition'])) {
                        if(this.related.solrField || this.related.solrCondition.length){
                            let prevValue;
                            if (changes['item']) {
                                prevValue = new ProductFullSolrDTO( changes['item'].previousValue );
                            }
                            if (this.item && (changes['item'] && prevValue.product_id_i !== this.item.product_id_i || changes['solrCondition'])) {
                                if(this.related.solrCondition){
                                    this.solrCondition = !this.solrCondition.length ? JSON.parse(JSON.stringify(this.related.solrCondition)) : this.solrCondition;
                                    for(let i in this.related.solrCondition){
                                        this.related.solrCondition[i].value = this.solrCondition[i].value.replace(/\<\%product.(.*?)\%\>/g, (($1, $2) => this.item[$2] ? this.item[$2]: $1));
                                    }
                                }
                                this._setRelatedProductItems(this.currLang, this.item.product_id_i, true);
                            }
                        }
                        else if(this.related.localstorage_key){
                            let productID = this.item ? this.item.product_id_i : -1;
                            this._setLatestViewedProductItems(this.currLang, productID, true);
                        }
                    }
                    else if(this.type == 'orderedProducts'){
                        let productID = this.item ? this.item.product_id_i : -1;
                        this._setLatestOrderedProductItems(this.currLang, productID, true);
                    } else if(this.type == 'entityRelatedProducts') {
                        this.getByEntityProductsCodeList();
                    }
                }
            });

    }

    initDataByGlobalProduct() {
        this.item = this.productPageService.mainProduct;
        this.langSvc
            .getCurrentLanguage$()
            .subscribe(lang => {
                if (lang) {
                    this.currLang = lang;
                    this.carouselBanner.RTL = this.langSvc.isRTL( lang );
                    if (this.type === 'promo' && GenericConfig.carouselHP && (this.key && EntityConfig.ngxProductsCarousel[this.key]  ) ) {
                        this._setRelatedProductItems(this.currLang, this.item?.product_id_i, true);
                    }
                    if (this.type === 'openRelatedItems') {
                        this.getProductsByCondition();
                    }
                    if (this.type === 'relatedItems') {
                        if(this.related.solrField || this.related.solrCondition.length){
                            if(this.related.solrCondition){
                                this.solrCondition = !this.solrCondition.length ? JSON.parse(JSON.stringify(this.related.solrCondition)) : this.solrCondition;
                                for(let i in this.related.solrCondition){
                                    this.related.solrCondition[i].value = this.solrCondition[i].value.replace(/\<\%product.(.*?)\%\>/g, (($1, $2) => this.item[$2] ? this.item[$2]: $1));
                                }
                            }
                            this._setRelatedProductItems(this.currLang, this.item.product_id_i, true);
                        }
                        else if(this.related.localstorage_key){
                            let productID = this.item ? this.item.product_id_i : -1;
                            this._setLatestViewedProductItems(this.currLang, productID, true);
                        }
                    }
                }
            });
    }

    getByEntityProductsCodeList() {
        this.solrEntityService.getSolrEntityByVar(this.entityVar).subscribe(res => {
            let productsCode = res['response']['docs'][0]['cp_related_products_ss'];
            this.solrService.getSolrByProductIds(this.currLang, productsCode).subscribe(items => {
                let products = items.sort((a, b) => {
                    return productsCode.indexOf(a.product_code_s) -  productsCode.indexOf(b.product_code_s)
                });
                this._getProductsPriceAction(_.map(products, (item) => item.product_id_i));
                this.items =  _.chunk(products, 1);
            })
        });
    }

    getByProductIds(lang: ILanguage, productId: number, force, items) {
        items = items || [];
        force = force || false;
        if (lang) {
            if (force || (!this.items || !this.items.length)) {
                this.loading = true;
                if (!items.length) {
                    this.loading = false;
                    this.items = [];
                    return;
                }
                this.solrService
                    .getSolrByProductIds(lang, items)
                    .subscribe(
                        (products: Array<ProductFullSolrDTO>) => {
                            this.loading = false;
                            this.items =  _.chunk(products, 1);
                            this.items.sort(function(a, b){
                                return items.indexOf((+a[0].product_id_i).toString()) - items.indexOf((+b[0].product_id_i).toString());
                            });
                            this._getProductsPriceAction(_.map(products, (item) => item.product_id_i));
                            if(this.inventoryCheck) {
                                this._getProductsStockAction(_.map(products, (item) => item.product_code_s));
                            }
                        });
            }
        }
    }

    getIsPromo(lang: ILanguage) {
        if (lang && this.relatedItemsField) {
            this.loading = true;
            this.solrService
                .getSolrIsPromo(lang, this.relatedItemsField)
                .subscribe(
                    (products: Array<ProductFullSolrDTO>) => {
                        this.loading = false;
                        this.items = _.chunk(products, this.configRows);
                        this._getProductsPriceAction(_.map(products, function (item) {return item.product_id_i}));
                        if(this.inventoryCheck) {
                            this._getProductsStockAction(_.map(products, (item) => item.product_code_s));
                        }
                    });
        }
    }

    protected _getProductsPriceAction(pIds: Array<number>) {
        if(GenericConfig.unCommerceApp) return;
        const action = CatalogueActions.getProductPrice(pIds);
        this.store$.dispatch(action);
    }

    protected _getProductsStockAction(pCodes: Array<any>) {
        const action = CatalogueActions.getProductsStock(pCodes);
        this.store$.dispatch(action);
    }

    protected _setRelatedProductItems(lang: ILanguage, productId: number, force = false) {
        if(productId !== -1 && this.related?.solrField && this.related?.solrCondition){
            this.getProductsBySolrIdsAndCodnitions(lang, productId, force, this.item[this.related.solrField], this.related.solrCondition);
        } else if (productId !== -1 && this.related?.solrField) {
            this.relatedItemsField = this.related.solrField;
            this.getByProductIds(lang, productId, force, this.item[this.relatedItemsField]);
        } else {
            if(this.key && EntityConfig.ngxProductsCarousel[this.key]){
               this.insertCustomElementRelated();
            }
            this.relatedItemsField = this.related?.solrCondition;
            this.getIsPromo(lang);
        }

    }

    protected _setLatestViewedProductItems(lang: ILanguage, productId: number, force = false) {
            let items = [];

            if(localStorage.getItem('last_viewed_items')) {
                let latestViewed = JSON.parse(localStorage.getItem('last_viewed_items'));
                latestViewed.sort((a,b) => (a.timestemp > b.timestemp) ? -1 : ((b.timestemp > a.timestemp) ? 1 : 0));
                items = latestViewed.map(a => a.product_id);
                if(productId > -1) {
                    items.splice(items.indexOf(productId), 1);
                }
                this.getByProductIds(lang, productId, force, items);

            }
    }

    protected _setLatestOrderedProductItems(lang: ILanguage, productId: number, force = false) {
        this.ordersService.getLastOrderedProducts().subscribe((data) => {
                if(data['productsIds']){
                    let items = data['productsIds'];
                    if(productId > -1) {
                        items.splice(items.indexOf(productId), 1);
                    }
                    this.getByProductIds(lang, productId, force, items);
                }
            }
        );
    }

    getProductsByCondition() {
        this.loading = true;
        const count = this.carouselBanner.grid.lg * 3;
        this.items = this.items || [];
        const page = ( this.items.length / count ) + 1;
        this.solrService
            .getSolrByConditions(this.openRuleCondition, this.item.product_id_i, this.currLang, page, count)
            .subscribe(
                (products: Array<ProductFullSolrDTO>) => {
                    this.loading = false;
                    this.items.push(...( _.chunk(products, 1)));
                    this._getProductsPriceAction(_.map(products, (item) => item.product_id_i));
                    if(this.inventoryCheck) {
                        this._getProductsStockAction(_.map(products, (item) => item.product_code_s));
                    }
                    this.cdr.detectChanges();
                });
                error => {
                    this.loading = false;
                }
    }

    getProductsBySolrIdsAndCodnitions(lang: ILanguage, productId: number, force, items, conditions) {
        items = items || [];
        force = force || false;
        if (lang) {
            if (force || (!this.items || !this.items.length)) {
                this.loading = true;
                if (!items.length) {
                    this.loading = false;
                    this.items = [];
                    return;
                }
                this.solrService
                    .getSolrByProductIdsAndConditions(lang, items, conditions)
                    .subscribe(
                        (products: Array<ProductFullSolrDTO>) => {
                            this.loading = false;
                            this.items =  _.chunk(products, 1);
                            this.items.sort(function(a, b){
                                return items.indexOf(+a[0].product_id_i) - items.indexOf(+b[0].product_id_i);
                            });
                            this._getProductsPriceAction(_.map(products, (item) => item.product_id_i));
                            if(this.inventoryCheck) {
                                this._getProductsStockAction(_.map(products, (item) => item.product_code_s));
                            }
                        });
            }
        }
        let sb1$ = this.priceList$.subscribe((priceList: PriceDTO[]) => {
            if(priceList && priceList.length) {
                if (this.items?.length) {
                    let numFound = 0;
                    let items = this.items.map((i) => {
                        let price = priceList.find((p) => p['id'] === i[0]?.id_s);
                        if (price) numFound++;
                        return {...i[0], price: price};
                    });
                    if (GenericConfig.GTM_ID && numFound === items.length) {
                        this.eventBusService.emit(new EventData(EventName.DATA_FOR_ANALYTICS_READY, {
                            page: 'view_item_list',
                            data: items
                        }));
                        sb1$.unsubscribe();
                    }
                }
            }
        });
        this.subscriptionsList$.push(sb1$);
    }

    ngOnDestroy() {
        _.each(this.subscriptionsList$, (s) => s.unsubscribe());
    }

    public carouselTileLoad(j) {
        if(this.type == 'openRelatedItems') {
            this.getProductsByCondition();
        }
    }
}
